import { apiClient } from '@copro/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { useSpace } from '../../../hooks/useSpace';
import { QuoteCompaisonColumnDatabase } from '../../../types';
import { keys } from './keys';

type DefaultColumn = Pick<QuoteCompaisonColumnDatabase, 'label' | 'type' | 'align' | 'order'>;

const DEFAULT_COLUMNS: DefaultColumn[] = [
  { label: 'Prix HT', type: 'number', align: 'right', order: 0 },
  { label: 'Prix TTC', type: 'number', align: 'right', order: 1 },
  { label: 'Commentaires', type: 'multiline', align: 'left', order: 2 },
];

async function postQuoteGroup(spaceId: string, name: string) {
  const { data: user } = await apiClient.auth.getUser();

  if (!user.user) {
    throw new Error('Votre session a expiré, reconnectez-vous.');
  }

  const { data: group, error } = await apiClient
    .from('quote_comparison_groups')
    .insert({ name, user_id: user.user.id, space_id: spaceId })
    .select()
    .single();

  if (error) {
    throw error;
  }

  const { error: columnsError } = await apiClient
    .from('quote_comparison_columns')
    .insert(DEFAULT_COLUMNS.map((column) => ({ ...column, group_id: group.id, visible: true })));

  if (columnsError) {
    throw columnsError;
  }

  return group;
}

export function usePostQuoteGroup() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: (name: string) => postQuoteGroup(currentSpace!.id, name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.groupsList(currentSpace!.id) });
      enqueueSnackbar('Comparaison créée.', 'success');
    },
  });
}
